(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('toggleFriend', toggleFriend);

    var noop = angular.noop,
        isDefined = angular.isDefined;

    toggleFriend.$inject = ['$q', 'Member', 'user', 'confirm', 'alert', 'core_resources'];
    function toggleFriend($q, Member, user, confirm, alert, resources) {
        return function toggleFriend(member, confirmOnDelete) {
            var dummy = validate(),
                isAdding = !member.isFriend,
                method = isAdding ? 'addFriend' : 'removeFriend',
                errorMessage = isAdding ? resources.addFriendError : resources.removeFriendError;

            return confirmIfNeeded().then(execute);

            function confirmIfNeeded() {
                return !isAdding && confirmOnDelete ? confirm(resources.removeFriendConfirmation, member.name) : $q.resolve();
            }

            function execute() {
                var id = member.individualId;
                return Member[method]({ id: user.id, friendId: id }, success, error, true).$promise;

                function success() {
                    member.isFriend = isAdding;
                }
                function error() {
                    alert.error(errorMessage, member.name);
                }
            }

            function validate() {
                var isOk = member && member.name && member.individualId && isDefined(member.isFriend);
                if (!isOk)
                    throw new Error(resources.toggleFriendArgumentError);
            }
        }
    }
})();